module.exports = __webpack_public_path__ + "static/media/Qworky_Logo.d30d946d.png";